import { urls } from 'src/components/packages/urls';
import { createHttpRequest } from 'src/utils/http-request';

import {
  ImmutabilityMode,
  ImmutableTagRulePatternTestResult,
  ImmutableTagRule,
  ImmutableTagSettings,
} from './types';

export const getImmutableTagSettings = (
  workspaceSlug: string
): Promise<ImmutableTagSettings> =>
  createHttpRequest<ImmutableTagSettings>('GET')(
    urls.api.internal.immutableTagSettings(workspaceSlug)
  );

export const updateImmutableTagSettings = (
  workspaceSlug: string,
  mode: ImmutabilityMode
): Promise<ImmutableTagSettings> =>
  createHttpRequest<ImmutableTagSettings>('PUT')(
    urls.api.internal.immutableTagSettings(workspaceSlug),
    { mode }
  );

export const createImmutableTagRule = (
  workspaceSlug: string,
  name: string,
  pattern: string
): Promise<ImmutableTagRule> =>
  createHttpRequest<ImmutableTagRule>('POST')(
    urls.api.internal.immutableTagRules(workspaceSlug),
    { name, pattern }
  );

export const testImmutableTagRulePattern = (
  workspaceSlug: string,
  pattern: string,
  sampleTag: string
): Promise<ImmutableTagRulePatternTestResult> =>
  createHttpRequest<ImmutableTagRulePatternTestResult>('POST')(
    urls.api.internal.immutableTagRulesTest(workspaceSlug),
    { pattern, tag_name: sampleTag }
  );

export const updateImmutableTagRule = (
  workspaceSlug: string,
  ruleUuid: string,
  name: string,
  pattern: string
): Promise<ImmutableTagRule> =>
  createHttpRequest<ImmutableTagRule>('PUT')(
    urls.api.internal.immutableTagRule(workspaceSlug, ruleUuid),
    { name, pattern }
  );

export const deleteImmutableTagRule = (
  workspaceSlug: string,
  ruleUuid: string
): Promise<void> =>
  createHttpRequest<void>('DELETE')(
    urls.api.internal.immutableTagRule(workspaceSlug, ruleUuid)
  );
